import constants from "../../constants";
import { sendToErrorTracker } from "../error";

let clockDriftMs = 0;

/**
 * Keep the clock drift updated externally by store middleware
 */
export function setClockDrift(drift: number) {
    clockDriftMs = drift;
}

/**
 * Gets the current date, adjusting to the clock drift.
 * If no date is provided, the current time is adjusted.
 * @returns The clock drift-adjusted current date
 */
export function getServerDate(): Date {
    // Make sure this is actually a date
    let date = new Date();

    // Don't adjust the date if it's outside min or max date
    if (date.getTime() <= constants.MIN_DATE.getTime()) {
        return constants.MIN_DATE;
    }

    if (date.getTime() >= constants.MAX_DATE.getTime()) {
        return constants.MAX_DATE;
    }

    let clockDrift = clockDriftMs;
    let driftedDate = new Date(date.getTime() + clockDrift);

    if (isNaN(driftedDate.getTime())) {
        // date is not valid
        sendToErrorTracker(new Error(`Invalid date exception: ${ date.toString() }, clock drift is ${ clockDrift }`), "javascript");
    }

    return driftedDate;
}

export function shiftDateTime(baseDate: Date, offsetInMs: number): Date {
    return new Date(baseDate.getTime() + offsetInMs);
}

/**
 * Calculates the difference between two dates in seconds.
 * @param date1 The first date
 * @param date2 The second date
 * @returns The difference in seconds (date1 - date2)
 */
export function getDateDifferenceInSeconds(date1: Date, date2: Date): number {
    return Math.floor((date1.getTime() - date2.getTime()) / 1000);
}